import React, {PropTypes, Component} from 'react';

// const Track = ({className, included, offset, length}) => {
//   const style = {
//     left: offset + '%',
//     width: length + '%',
//     visibility: included ? 'visible' : 'hidden',
//   };
//   return <div className={className} style={style} />;
// };

class Track extends Component {
  render() {
    const {included, offset, length, className} = this.props;
    const style = {
      left: offset + '%',
      width: length + '%',
      visibility: included ? 'visible' : 'hidden'
    };
    return <div className={className} style={style} />;
  }
}

Track.propTypes = {
  included: PropTypes.bool.isRequired,
  offset: PropTypes.number.isRequired,
  className: PropTypes.string.isRequired,
  length: PropTypes.number.isRequired
};

export default Track;
